/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Timespent1Inputs */

const zh_learn_timespent1 = /** @type {(inputs: Learn_Timespent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用时`)
};

const en_learn_timespent1 = /** @type {(inputs: Learn_Timespent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time spent`)
};

const es_learn_timespent1 = /** @type {(inputs: Learn_Timespent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo total`)
};

/**
* | output |
* | --- |
* | "Time spent" |
*
* @param {Learn_Timespent1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_timespent1 = /** @type {((inputs?: Learn_Timespent1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Timespent1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_timespent1(inputs)
	if (locale === "en") return en_learn_timespent1(inputs)
	return es_learn_timespent1(inputs)
});
export { learn_timespent1 as "learn_timeSpent" }